import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { guaranteePoints } from '../data/offer';
export function Guarantee() {
  return <section className="w-full bg-moss-soft" aria-labelledby="guarantee-heading" data-id="element-121" data-mp="223y4543nw1ij">
      <div className="mx-auto grid max-w-5xl gap-7 px-4 py-14 sm:gap-10 sm:px-5 sm:py-24 lg:grid-cols-[auto_1fr] lg:items-start lg:gap-14" data-id="element-122" data-mp="1x4bpcq86qd7m">
        <div className="flex h-20 w-20 items-center justify-center rounded-full border-2 border-moss/25 bg-white sm:h-28 sm:w-28" aria-hidden="true" data-id="element-123" data-mp="19fismrjqo1by">
          <ShieldCheckIcon className="h-9 w-9 text-moss sm:h-12 sm:w-12" data-id="element-124" data-mp="1j4tz06f8qrw5" />
        </div>

        <div data-id="element-125" data-mp="1edbxnh9b2pan">
          <SectionLabel data-id="element-126" data-mp="1edk872hyhiio">Zero risk · 100% protected</SectionLabel>

          <h2 id="guarantee-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.5rem]" data-id="element-127" data-mp="qo9gsbmhx0h7">
            30-Day “Happy Tail” Guarantee
          </h2>

          <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-ink/80 sm:mt-6 sm:text-lg" data-id="element-128" data-mp="oygncjtz1mcx">
            Try the system for 30 days. If you don’t see a dramatic
            transformation in your dog’s behavior—if they aren’t calmer, more
            obedient, and easier to walk—simply send us an email. We will refund
            every penny, and{' '}
            <strong className="font-semibold text-ink" data-id="element-129" data-mp="60nktin9feg2">
              you can keep the program anyway
            </strong>
            . That is how much we trust this method.
          </p>

          <ul className="mt-7 flex flex-wrap gap-2 sm:mt-9 sm:gap-3" data-id="element-130" data-mp="b1l9me2rz6qj">
            {guaranteePoints.map(point => <li key={point} className="flex items-center gap-2 rounded-full border border-moss/25 bg-white px-3.5 py-2 text-[11px] font-bold uppercase tracking-[0.12em] text-ink/75" data-id="element-131" data-mp="k06sybg2mpsd">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-moss" aria-hidden="true" data-id="element-132" data-mp="1veaj16jjfts5" />
                {point}
              </li>)}
          </ul>

          <p className="mt-6 font-display text-base italic text-moss sm:mt-7 sm:text-lg" data-id="element-133" data-mp="3nglinhq34b40">
            Satisfaction guaranteed, or your money back.
          </p>
        </div>
      </div>
    </section>;
}